import { useMemo, type FC } from 'react';
import { StyleSheet, View } from 'react-native';

import { FeedEmpty, FeedEmptyAction, FeedEnd } from '@/assets';

const makeStyles = () =>
  StyleSheet.create({
    image: { width: '100%' },
    container: {
      gap: 20,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginVertical: 32,
      paddingBottom: 80
    }
  });

type Props = { state?: 'end' | 'empty' | 'empty_action' };

export const FeedStateView: FC<Props> = ({ state = 'end' }) => {
  const styles = useMemo(() => makeStyles(), []);

  return (
    <View style={styles.container} testID={`feed-state-${state}`}>
      {state === 'end' && <FeedEnd style={styles.image} />}
      {state === 'empty' && <FeedEmpty style={styles.image} />}
      {state === 'empty_action' && <FeedEmptyAction style={styles.image} />}
    </View>
  );
};
